module.exports = __webpack_public_path__ + "media/images/simulation/ic_print-cadd3df0b8d62beeeb676acf78884f70.svg";